export const COMMUNITY = '/access/community/?limit=5000';
